import classNames from "classnames";
import uniqueId from "lodash/uniqueId";
import * as React from "react";
import { ProgressBarBand } from "@app/shared/progressBarBand";
import { JSX } from "react";
import TooltipWrapper from "@app/shared/TooltipWrapper";

interface ProgressBarProps {
  bands: ProgressBarBand[];
  isGrayscale: boolean;
  isCompared?: boolean;
  isMuted?: boolean;
}

const ProgressBar = (props: ProgressBarProps): JSX.Element => {
  let classes: string = classNames("progress p0-imp m0-imp");
  const progressBarId: string = React.useMemo(() => uniqueId("progress-bar-"), []);
  const styleHeight: React.CSSProperties = { height: 21 };
  const valuesExist: boolean = props.bands.length > 0;

  if (props.isCompared) {
    classes = classes + " mt8-imp";
  }

  if (props.isMuted || !valuesExist) {
    return (
      <div className={classes} style={styleHeight} id={progressBarId}>
        <div className="progress-bar progress-bar-muted" role="figure" style={{ width: `100%` }} />
      </div>
    );
  } else {
    classes = classNames(classes, { grayscale: props.isGrayscale });

    return (
      <div className={classes} style={styleHeight} id={progressBarId}>
        {props.bands.map((band, i) => (
          <div
            className={`progress-bar${band.colorType === "class" ? (" " + band.color) : ""}`}
            role="figure"
            key={i}
            style={{
              backgroundColor: band.colorType === "hex" && band.color,
              width: band.percent ? `${Math.max(5, band.percent)}%` : "0",
            }}
            aria-label={band.label ? `${band.percent}% ${band.label}` : undefined}
          >
            <TooltipWrapper text={band.tooltip} triggerWidth="100%" />
          </div>
        ))}
      </div>
    );
  }
};

export { ProgressBar };
